import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { service } from '@ember/service';

export default class InterVarsityProspectsRoute extends Route {
  @service abilities;
  @service navbarSettings;

  beforeModel(transition) {
    if (this.abilities.noAbility('import_iv_prospects')) {
      transition.abort();
    } else {
      set(this, 'navbarSettings.title', 'Import InterVarsity Prospects');
    }
  }

  model() {
    return { selectedFile: null };
  }
}
